<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.administratorViewRecordList.push"
    :is-show-store-select="true"
    :is-multiple-store="true"
    :has-private-store="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
    :is-show-administrator-select="true"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-last-thirty-day="true"
    administrator-select-label="浏览账号"
    search-placeholder="输入页面名称或路径以搜索"
  >
    <v-column-time value="浏览时间"/>
    <el-table-column label="浏览记录 ID" prop="id" width="100px"/>
    <v-column-admin label="浏览账号"/>
    <el-table-column label="账号所属门店">
      <template v-slot="{ row }">{{ row.store_name | formatStoreName }}</template>
    </el-table-column>
    <el-table-column label="浏览页面名称" prop="page_name"/>
    <el-table-column label="浏览页面路径">
      <template v-slot="{ row }">
        <router-link :to="row.page_path" class="primary-color">{{ row.page_path }}</router-link>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`view-record-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>浏览时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>浏览记录 ID</span>
              <span>{{ v.id }}</span>
            </div>

            <div class="list-item-detail">
              <span>浏览账号</span>
              <v-avatar-nickname
                :value="v.administrator_avatar"
                :nickname="v.administrator_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>账号所属门店</span>
              <span>{{ v.store_name | formatStoreName }}</span>
            </div>

            <div class="list-item-detail">
              <span>浏览页面名称</span>
              <span>{{ v.page_name }}</span>
            </div>

            <div class="list-item-detail">
              <span class="flex-shrink">浏览页面路径</span>
              <router-link :to="v.page_path" class="list-item-info primary-color">{{ v.page_path }}</router-link>
            </div>

            <div class="list-item-button"></div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>

  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { getLegalQueryList } from '@/utils/formats';
import { getViewRecords } from '@/api/administrator';
import { checkYmdIsBetweenSetUpAndToday } from "@/utils/validate";

export default {
  name: RouteConfig.administratorViewRecordList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    queryList: {
      administrator_ids: [],
      store_ids: [],
      start_date: '',
      end_date: '',
      keyword: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load(this.$route);
  },
  methods: {
    async load({ query }) {
      const { queryList } = this;
      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
      const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      } else {
        queryList.start_date = '';
        queryList.end_date = '';
      }

      this.isLoading = true;
      const { isError, data } = await getViewRecords(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
    },
  },
};
</script>
